import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface TokenSummary {
    type: string;
    createdAt: string;
    expiresAt: string;
    isExpired: boolean;
}

export interface LoginAttemptSummary {
    attemptedAt: string;
    ipAddress: string;
}

export interface PasskeySummary {
    id: number;
    deviceName: string;
    createdAt: string;
    lastUsedAt: string | null;
}

export interface UserSecurityResponse {
    lastLoginAt: string | null;
    passwordChangedAt: string | null;
    tokens: TokenSummary[];
    loginAttempts: LoginAttemptSummary[];
    passkeys: PasskeySummary[];
}

export function useUserSecurity(userId: number | null) {
    return useQuery<UserSecurityResponse>({
        queryKey: ['admin', 'users', userId, 'security'],
        queryFn: () => api.get(`/api/admin/users/${userId}/security`),
        enabled: userId !== null,
    });
}
